// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { sapphireTestnet as _sapphireTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the sapphireTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 23295
 * Chain Name: Oasis Sapphire Testnet
 * Default Block Explorer: https://explorer.oasis.io/testnet/sapphire
 * Default RPC URL: https://testnet.sapphire.oasis.dev
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { sapphireTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: sapphireTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const sapphireTestnet = createCommon({
	..._sapphireTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
